<template>
  <v-container v-if="curso">
    <v-row>
      <v-col cols="12">
        <v-btn text class="ui-back-btn" @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
      </v-col>
      <v-col cols="12" lg="8" offset-lg="2">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="ui-module-titlebar font-weight-bold justify-center">Registrar candidatos</v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    class="ui-form-field"
                    :value="curso.subcategoria"
                    rounded
                    filled
                    dense
                    background-color="transparent"
                    color="secondary"
                    label="Capacitación"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    class="ui-form-field"
                    v-model="busquedaPersonal.nombre"
                    rounded
                    filled
                    dense
                    background-color="transparent"
                    color="secondary"
                    label="Nombre"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    class="ui-form-field"
                    v-model="busquedaPersonal.apaterno"
                    rounded
                    filled
                    dense
                    background-color="transparent"
                    color="secondary"
                    label="Apellido paterno"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    class="ui-form-field"
                    v-model="busquedaPersonal.amaterno"
                    rounded
                    filled
                    dense
                    background-color="transparent"
                    color="secondary"
                    label="Apellido materno"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    class="ui-form-field"
                    v-model="busquedaPersonal.CUIP"
                    rounded
                    filled
                    dense
                    background-color="transparent"
                    color="secondary"
                    label="CUIP"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="d-flex align-center justify-center">
                  <v-btn
                    color="secondary"
                    class="ui-module-btn-solid"
                    :loading="loadingBusquedaPersonal"
                    :disabled="loadingBusquedaPersonal"
                    @click="buscarPersonalCandidato"
                  >
                    Buscar <v-icon small class="ml-2">mdi-magnify</v-icon>
                  </v-btn>
                </v-col>

                <v-col cols="12">
                  <div class="text-subtitle-2 font-weight-bold secondary--text mb-2">Personal disponible</div>
                  <v-list dense class="candidatos-list">
                    <v-list-item v-for="item in personalDisponibleFiltrado" :key="item.idPersonal">
                      <v-list-item-content>
                        <v-list-item-title>{{ getFullName(item) }}</v-list-item-title>
                        <v-list-item-subtitle>{{ item.CUIP || 'CUIP no asignado' }}</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn
                          small
                          color="secondary"
                          class="ui-module-btn-solid"
                          :loading="vinculandoId === item.idPersonal"
                          :disabled="vinculando"
                          @click="vincularCandidato(item)"
                        >
                          Agregar
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                    <v-list-item v-if="!loadingBusquedaPersonal && personalDisponibleFiltrado.length === 0">
                      <v-list-item-content>
                        <div class="text-body-2 text-center">
                          {{
                            personal.length === 0
                              ? 'Busca personal por nombre para ver resultados'
                              : 'No se encontraron elementos disponibles'
                          }}
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>

              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { ESTATUS_CURSO_PERSONAL_PENDIENTE } from '@/const'

export default {
  props: {
    id: {
      type: Number,
    },
  },

  data() {
    return {
      loadingBusquedaPersonal: false,
      vinculando: false,
      vinculandoId: null,
      busquedaPersonal: {
        nombre: '',
        apaterno: '',
        amaterno: '',
        CUIP: '',
      },
    }
  },

  async mounted() {
    await Promise.all([this.fetchCursosNoProgramadosPersonal(), this.fetchEstatusCursoPersonal(), this.fetchCursos()])
  },

  beforeDestroy() {
    this.SET_PERSONAL([])
  },

  computed: {
    ...mapGetters('capacitaciones', { cursosNoProgramadosPersonal: 'getCursosNoProgramadosPersonal' }),
    ...mapGetters('personal', { personal: 'getPersonal' }),
    ...mapGetters('curso', { cursosCatalogo: 'getCursos' }),

    curso() {
      return this.cursosCatalogo.find((c) => c.id === this.id) || null
    },

    candidatosVinculados() {
      return this.cursosNoProgramadosPersonal.filter((vinculado) => vinculado.fk_idCurso === this.id)
    },

    personalDisponibleFiltrado() {
      const idsVinculados = new Set(this.candidatosVinculados.map((v) => v.fk_idPersonal))
      return this.personal.filter((p) => !idsVinculados.has(p.idPersonal))
    },
  },

  methods: {
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapMutations('personal', ['SET_PERSONAL']),
    ...mapMutations('capacitaciones', ['SET_CUIP_PERSONAL']),
    ...mapActions('personal', ['searchPersonal']),
    ...mapActions('estatusCursoPersonal', ['fetchEstatusCursoPersonal']),
    ...mapActions('curso', ['fetchCursos']),
    ...mapActions('capacitaciones', ['fetchCursosNoProgramadosPersonal', 'vincularPersonalACurso']),

    getFullName(persona) {
      if (!persona) return ''
      return [persona.nombre, persona.segundoNombre, persona.apaterno, persona.amaterno].filter(Boolean).join(' ')
    },

    async buscarPersonalCandidato() {
      this.loadingBusquedaPersonal = true
      try {
        await this.searchPersonal(this.busquedaPersonal)
      } finally {
        this.loadingBusquedaPersonal = false
      }
    },

    async vincularCandidato(persona) {
      // NOTA (EDF-374): el selector de estatus se movió al modal de edición
      // en EvaluaCurso.vue (donde se registran las calificaciones); aquí solo
      // se vincula con el estatus "Pendiente" como valor temporal, ya que el
      // API lo exige obligatorio al crear el registro.
      this.vinculando = true
      this.vinculandoId = persona.idPersonal
      try {
        await this.vincularPersonalACurso({
          fk_idPersonal: persona.idPersonal,
          fk_idCurso: this.id,
          fk_idEstatus: ESTATUS_CURSO_PERSONAL_PENDIENTE,
        })
        this.SET_CUIP_PERSONAL({ fk_idPersonal: persona.idPersonal, cuip: persona.CUIP })
        await this.fetchCursosNoProgramadosPersonal()
      } finally {
        this.vinculando = false
        this.vinculandoId = null
      }
    },
  },
}
</script>

<style scoped>
.ui-back-btn {
  color: #26de81 !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(0, 210, 160, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(0, 210, 160, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .mdi-menu-down {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .ui-form-field .v-label--active {
  color: #26de81 !important;
}

::v-deep .ui-module-btn-solid {
  background: linear-gradient(135deg, #00d2a0 0%, #26de81 100%) !important;
  color: #062118 !important;
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  box-shadow: 0 8px 24px rgba(0, 210, 160, 0.28) !important;
}

.candidatos-list {
  background: transparent !important;
  max-height: 260px;
  overflow-y: auto;
}
</style>
